<template>
  <div class="fillvoucher">
    <div class="fill">
      <div class="row" style="display: -webkit-block;display: block;overflow:hidden;">

        <div class="viewresults" @click="toMyard" style="float:right;">我的检测卡</div>

      </div>

      <div class="item">
        <div class="left">被检测人姓名</div>
        <div class="right"><input type="text" placeholder="请输入被检测人姓名" v-model="parameter.user_name"></input></div>
      </div>
      <div class="item">
        <div class="left">检测日期</div>
        <div class="right"><input type="text" readonly placeholder="请输入检测日期" v-model="parameter.inspection_date"
                                  @click="showDatePicker"></input></div>
      </div>
      <div class="item">
        <div class="left">手机号码</div>
        <div class="right"><input type="text" placeholder="请输入手机号码" v-model="parameter.phone"></input></div>
      </div>
      <div class="item">
        <div class="left">性别</div>
        <div class="right sex">
          <van-radio-group v-model="parameter.sex">
            <van-radio name="男" checked-color="#44B5FF" :icon-size="isiOS">男</van-radio>
            <van-radio name="女" checked-color="#44B5FF" :icon-size="isiOS" class="tworadio">女</van-radio>
          </van-radio-group>
        </div>
      </div>
      <!-- 	<div class="item">
        <div class="left">您的姓名</div>
        <div class="right"><input type="text" placeholder="输入您的真实姓名"></input></div>
      </div> -->
      <div class="item">
        <div class="left">您的年龄</div>
        <div class="right age">
          <van-radio-group v-model="parameter.age">
            <van-radio name="1" checked-color="#44B5FF" :icon-size="isiOS" class="ageitem">17岁及以下</van-radio>
            <van-radio name="2" checked-color="#44B5FF" :icon-size="isiOS" class="ageitem">18-40岁</van-radio>
            <van-radio name="3" checked-color="#44B5FF" :icon-size="isiOS" class="ageitem">41-65岁</van-radio>
            <van-radio name="4" checked-color="#44B5FF" :icon-size="isiOS" class="ageitem">65岁以上</van-radio>
          </van-radio-group>
        </div>
      </div>
      <!-- <div class="item">
        <div class="left">备孕状态</div>
        <div class="right age">
          <van-radio-group v-model="parameter.age">
            <van-radio name="1" checked-color="#44B5FF" :icon-size="isiOS" class="ageitem">备孕</van-radio>
            <van-radio name="2" checked-color="#44B5FF" :icon-size="isiOS" class="ageitem">已孕</van-radio>
            <van-radio name="3" checked-color="#44B5FF" :icon-size="isiOS" class="ageitem">其他</van-radio>
          </van-radio-group>
        </div>
      </div> -->
      <div class="item">
        <div class="left">尼古丁</div>
        <div class="right sex">
          <van-radio-group v-model="parameter.nicotine">
            <van-radio name="1" checked-color="#44B5FF" :icon-size="isiOS">阳性</van-radio>
            <van-radio name="2" checked-color="#44B5FF" :icon-size="isiOS" class="tworadio">阴性</van-radio>
            <van-radio name="0" checked-color="#44B5FF" :icon-size="isiOS" class="tworadio">未检测</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="item">
        <div class="left">双酚A</div>
        <div class="right sex">
          <van-radio-group v-model="parameter.bpa">
            <van-radio name="1" checked-color="#44B5FF" :icon-size="isiOS">阳性</van-radio>
            <van-radio name="2" checked-color="#44B5FF" :icon-size="isiOS" class="tworadio">阴性</van-radio>
            <van-radio name="0" checked-color="#44B5FF" :icon-size="isiOS" class="tworadio">未检测</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="item">
        <div class="left">柠檬黄</div>
        <div class="right sex">
          <van-radio-group v-model="parameter.lemon_yellow">
            <van-radio name="1" checked-color="#44B5FF" :icon-size="isiOS">阳性</van-radio>
            <van-radio name="2" checked-color="#44B5FF" :icon-size="isiOS" class="tworadio">阴性</van-radio>
            <van-radio name="0" checked-color="#44B5FF" :icon-size="isiOS" class="tworadio">未检测</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="item">
        <div class="left">瘦肉精</div>
        <div class="right sex">
          <van-radio-group v-model="parameter.brown_meat">
            <van-radio name="1" checked-color="#44B5FF" :icon-size="isiOS">阳性</van-radio>
            <van-radio name="2" checked-color="#44B5FF" :icon-size="isiOS" class="tworadio">阴性</van-radio>
            <van-radio name="0" checked-color="#44B5FF" :icon-size="isiOS" class="tworadio">未检测</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="item">
        <div class="left">氯霉素</div>
        <div class="right sex">
          <van-radio-group v-model="parameter.chloramphenicol">
            <van-radio name="1" checked-color="#44B5FF" :icon-size="isiOS">阳性</van-radio>
            <van-radio name="2" checked-color="#44B5FF" :icon-size="isiOS" class="tworadio">阴性</van-radio>
            <van-radio name="0" checked-color="#44B5FF" :icon-size="isiOS" class="tworadio">未检测</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="item">
        <div class="left">其他情况</div>
        <div class="right"><input type="text" placeholder="您的检测卡是否有其他异常情况？" v-model="parameter.other"></input></div>
      </div>
      <div class="item" style="align-items: center;" :class="parameter.img!=''?'borderbotom':''">
        <div class="left">上传检测卡</div>
        <div class="right" style="display: flex;align-items: center;">
          <!-- <img :src="parameter.img" class="upimg"> -->
          <div class="cliup"><input type="file" accept="image/*" id="aa" @change="uploadHeadImg1">点击上传检测卡</input></div>
        </div>
      </div>
      <div class="item" style="align-items: center;border-bottom:none;" v-if="parameter.img!=''">
        <div class="left"></div>
        <div class="right" style="display: flex;align-items: center;">
          <img :src="parameter.img" class="upimg">
        </div>
      </div>
    </div>
    <div class="row">
      <!--      <div class="viewresults" @click="addscanCode" :disabled="butque">确定</div>-->
      <button class="viewresults" @click="addscanCode" id="viewresults" :disabled="butque">确定</button>
      <!-- <div class="viewresults" @click="updatescanCode" >确定</div> -->
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import $axios from 'axios'
  import {
    RadioGroup,
    Radio
  } from 'vant'

  Vue.use(RadioGroup)
  Vue.use(Radio)
  import {
    formatDate
  } from '../assets/date.js'
  import {
    Toast
  } from 'vant'

  Vue.use(Toast)
  export default {
    data() {
      return {
        isiOS: '17px',
        minDate: new Date(),
        radio: '1',
        appid: '',
        parameter: {
          user_name: '',
          phone: '',
          sex: '',
          age: '',
          inspection_date: '',
          nicotine: '',
          bpa: '',
          lemon_yellow: '',
          brown_meat: '',
          chloramphenicol: '',
          other: '',
          img: '',
          type: 1,
          code: ''
        },
        butque: false
      }
    },
    created() {
      let that = this
      var u = navigator.userAgent
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (isiOS == true) {
        console.log('进来啊')
        that.isiOS = '42px'
      } else {
        console.log('进来啊1')
        that.isiOS = '17px'
      }
      console.log(that.isiOS)

      if (that.$utils.getUrlKey('code') != undefined) {
        that.parameter.code = that.$utils.getUrlKey('code')
      } else {
        that.getusercode()
      }
    },
    methods: {
      //获取code
      getusercode() {
        let _this = this
        _this.$http.api.getAppId({}).then(result => {
          _this.appid = result
          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + _this.appid +
            '&redirect_uri=' + encodeURIComponent('http://enshi.ensgene.com/#/fillvoucher2?esjy=ca2163a9') +
            '&response_type=code&scope=snsapi_userinfo#wechat_redirect'
        })
      },

// 跳转我的检测卡
      toMyard() {
        if (localStorage.getItem('user_id')) {
          this.$router.push({ name: 'mytestcard' })
        } else {
          /*
          this.$router.push({ name: 'login' })

           */
          window.location.href = this.$store.state.windowhref
        }
      },

      //添加监测卡
      addscanCode() {
        let that = this
        if (that.parameter.user_name.trim() == '') {
          Toast({
            message: '姓名你不能为空',
            duration: 1500
          })
          return false
        }
        if (that.parameter.inspection_date.trim() == '') {
          Toast({
            message: '监测日期不能为空',
            duration: 1500
          })
          return false
        }
        if (that.parameter.phone.trim() == '') {
          Toast({
            message: '手机号码不能为空',
            duration: 1500
          })
          return false
        }
        if (that.parameter.sex == '') {
          Toast({
            message: '性别能为空',
            duration: 1500
          })
          return false
        }
        if (that.parameter.age == '') {
          Toast({
            message: '年龄不能为空',
            duration: 1500
          })
          return false
        }
        if (that.parameter.nicotine == '') {
          Toast({
            message: '尼古丁不能为空',
            duration: 1500
          })
          return false
        }
        if (that.parameter.bpa == '') {
          Toast({
            message: '双酚A不能为空',
            duration: 1500
          })
          return false
        }
        if (that.parameter.lemon_yellow == '') {
          Toast({
            message: '柠檬黄不能为空',
            duration: 1500
          })
          return false
        }
        if (that.parameter.brown_meat == '') {
          Toast({
            message: '瘦肉精不能为空',
            duration: 1500
          })
          return false
        }
        if (that.parameter.chloramphenicol == '') {
          Toast({
            message: '氯霉素不能为空',
            duration: 1500
          })
          return false
        }
        if (that.parameter.img == '') {
          Toast({
            message: '请上传检测卡',
            duration: 1500
          })
          return false
        }

        that.butque = true
        document.getElementById('viewresults').style.background = '#ccc '
        console.log('success')

        that.$http.api.scanCode(that.parameter).then(function (response) {

          Toast.success({
            duration: 1200,
            message: '操作成功'
          })

          // console.log(response)
          setTimeout(function () {
            that.$router.push({
              path: '/monitoringresults',
              query: {
                id: response
              }
            })
          }, 1500)


        })

      },
      //上传检测卡
      uploadHeadImg1(file) {
        var that = this
        if (file.target.files[0]) {
          let message = '上传中...'
          const toast = Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            mask: true,
            message: message
          })
          var reader = new FileReader()
          reader.onload = function (evt) {
            var images = new Image()
            images.src = evt.target.result
            images.onload = function () {
              var imgData = that.getBase64Image(images)
              // let formData = new FormData();
              // formData.append('file', imgData);
              $axios.post(that.commonurl + '/api/uploadImgBase64', {
                file: imgData
              }, {
                headers: {}
              }).then((res) => {
                if (res.data.status == 200) {
                  toast.message = '上传成功'
                  that.parameter.img = res.data.obj
                  Toast.clear()
                } else {
                  Toast.clear()
                }
              })
            }
          }
          reader.readAsDataURL(file.target.files[0])
        }
      },
      //压缩图片转成base64
      getBase64Image(img) {
        var canvas = document.createElement('canvas')
        var width = Math.min(400, img.width)
        var height = img.height * (width / img.width)
        canvas.width = width
        canvas.height = height
        var ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, width, height)
        var dataUrl = canvas.toDataURL('image/png', 0.1)
        return dataUrl
      },
      //日期选择
      showDatePicker() {
        if (!this.datePicker) {
          this.datePicker = this.$createDatePicker({

            min: new Date(),
            max: new Date(2050, 9, 20),
            value: new Date(),
            format: {
              year: 'YYYY年',
              month: 'MM月',
              date: 'D日'
            },
            onSelect: this.selectHandle,
            onCancel: this.cancelHandle
          })
        }

        this.datePicker.show()
      },
      selectHandle(date, selectedVal, selectedText) {
        let that = this
        that.parameter.inspection_date = formatDate(new Date(date), 'yyyy-MM-dd')
        console.log(date)
      },
      cancelHandle() {
        // this.$createToast({
        // 	type: 'correct',
        // 	txt: 'Picker canceled',
        // 	time: 1000
        // }).show()
      }
    }
  }
</script>
<style>
  .cube-picker-cancel,
  .cube-picker-confirm {
    font-size: 0.38rem;
  }

  .cube-picker-wheel-item {
    font-size: 0.38rem;
  }

  .sex .van-radio-group {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    align-items: center;
    font-size: 13px;
  }

  .fillvoucher .van-radio {
    display: -webkit-box !important;
  }

  .fillvoucher .van-radio__icon .van-icon {
    border-radius: 0px !important;
  }

  .sex .tworadio {
    margin-left: 20px;
  }
</style>
<style scoped lang="less">
  .borderbotom {
    border-bottom: none !important;
  }

  .upimg {
    width: 2.2rem;
    height: auto;
    margin-right: 0.4rem;
  }

  #aa {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 999;
    opacity: 0;
  }

  .fillvoucher {
    width: 100%;
    height: auto;
    background-color: #fff;
    padding: 15px 14px;
    box-sizing: border-box;

    .row {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      margin: 20px auto;

      .viewresults {
        color: #fff;
        font-size: 14px;
        background-color: #44B5FF;
        border-radius: 18px;
        padding: 5px 19px;
        border: none;
        box-sizing: border-box;
        text-align: center;
        // width: 2.4rem !important;
        width: 3rem !important;
        margin: 0 0.2rem;
      }
    }

    .fill {
      border-radius: 4px;
      border: 1px solid #efefef;

      .item {
        padding: 13px 15px;
        box-sizing: border-box;
        color: #022222;
        font-size: 13px;
        border-bottom: 1px solid #efefef;
        display: flex;
        display: -webkit-flex;

        .cliup {
          position: relative;
          border: 1px solid #E0E0E0;
          color: #022222;
          font-size: 12px;
          padding: 5px 7px;
        }

        .left {
          width: 30%;
        }

        .right {
          flex: 1;

          input {
            width: 100% !important;
            font-size: 13px;
            font-weight: 400;
            color: #022222;
          }
        }

        .age .ageitem {
          margin-bottom: 14px;
        }

        .age .ageitem:last-child {
          margin-bottom: 0px !important;
        }

      }

      .item:last-child {
        border-bottom: none;
      }
    }
  }
</style>
